import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getSituationList } from "../clients/KompasApi";
import { Page } from "../compositions/Page";
import { Box, Skeleton, Text } from "@chakra-ui/react";

export function ResidencePageRedirect() {
  const params = useParams<{ residenceId: string }>();
  const residenceTypeId = Number(params.residenceId ?? "0");
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>();

  const onError = useCallback((e: unknown) => {
    setError(e);
  }, []);

  useEffect(() => {
    if (!residenceTypeId) return;

    const abortController = new AbortController();

    getSituationList({
      path: { residenceTypeId },
      query: { Limit: 1, Offset: 0 },
      signal: abortController.signal,
      throwOnError: true,
    })
      .then(({ data }) => {
        if (abortController.signal.aborted) return;

        if (data?.items?.length) {
          navigate(
            `/residence/${residenceTypeId}/situation/${data.items[0].id}`,
            { replace: true }
          );
        } else {
          throw new Error(
            `No situations found for residence: ${residenceTypeId}`
          );
        }
      })
      .catch((e) => {
        if (abortController.signal.aborted) return;

        onError(e);
      });

    return () => abortController.abort("Component unmounted or re-rendered");
  }, [residenceTypeId, navigate, onError]);

  return (
    <Page>
      {error ? (
        <Box color="brand.red.100">
          <Text>Er was een probleem met het ophalen van de situaties:</Text>
          <Text>{String(error)}</Text>
          <Link color="brand.blue.100" to="/">
            Terug naar de startpagina
          </Link>
        </Box>
      ) : (
        <Skeleton height="100" width="100%" />
      )}
    </Page>
  );
}
